module.exports = __webpack_public_path__ + "static/assets/ac73372ae63d70afb8f9854cc04b436c.png";